interface IAppEnv {
  WS_URL: string
  WS_DISTRIBUTED_URL: string
  WS_PING_INTERVAL: string
  API_URL: string
  API_SINGLE_PLAYER_URL: string
  CONTROLLER_URL: string
  API_RAFFLE_URL: string
  VERSION: string
}

export const appEnv: IAppEnv = {
  WS_URL: import.meta.env.VITE_WS_URL || '$ENV{WS_URL}',
  WS_DISTRIBUTED_URL: import.meta.env.VITE_WS_DISTRIBUTED_URL || '$ENV{WS_DISTRIBUTED_URL}',
  WS_PING_INTERVAL: import.meta.env.VITE_WS_PING_INTERVAL || '$ENV{WS_PING_INTERVAL}',

  API_URL: import.meta.env.VITE_API_URL || '$ENV{API_URL}',

  CONTROLLER_URL: import.meta.env.VITE_CONTROLLER_URL || '$ENV{CONTROLLER_URL}',
  API_SINGLE_PLAYER_URL:
    import.meta.env.VITE_API_SINGLE_PLAYER_URL || '$ENV{API_SINGLE_PLAYER_URL}',

  API_RAFFLE_URL: import.meta.env.VITE_API_RAFFLE_URL || '$ENV{API_RAFFLE_URL}',
  VERSION: import.meta.env.VITE_VERSION || '$ENV{VITE_VERSION}',
}
